import React from 'react'
import { Stack, Box, Button, Skeleton } from '@chakra-ui/react'

interface Classes {
  title: any
  subtitle: any
  wrapper?: any
}

interface InformativeLayerProps {
  title: React.ReactNode
  subtitle: React.ReactNode
  pretitle?: React.ReactNode
  Image: React.ReactNode
  action?: () => any
  isLoading?: boolean
  classes?: Classes
  textButton?: string
  support?: React.ReactNode
}

const InformativeLayer: React.FC<InformativeLayerProps> = ({
  title,
  subtitle,
  pretitle,
  Image,
  action,
  isLoading = false,
  classes,
  textButton = 'Iniciar sesión',
  support,
}) => (
  <Box>
    <Stack spacing={5} align='center' m={20}>
      <Skeleton isLoaded={!isLoading}>{Image}</Skeleton>
      <Skeleton isLoaded={!isLoading}>
        {pretitle && (
          <Box m='2rem auto 0' maxW='md'>
            {pretitle}
          </Box>
        )}
        <Box m='0 auto' data-testid='layer-title'>
          {title}
        </Box>
      </Skeleton>
      <Skeleton isLoaded={!isLoading}>
        <Box maxW='md' data-testid='layer-subtitle'>
          {subtitle}
        </Box>
      </Skeleton>

      {typeof action === 'function' && textButton && (
        <Skeleton isLoaded={!isLoading}>
          <Box data-testid='action'>
            <Button mt={10} minW='204px' onClick={() => action()}>
              {' '}
              {textButton}{' '}
            </Button>
          </Box>
        </Skeleton>
      )}
      {support}
    </Stack>
  </Box>
)

export default InformativeLayer
